/**
 * 资源标签管理主控制器
 * hejianbo
 */
angular.module('mediaTagManagerModule', ['mediaTagServiceModule']).controller('mediaTagCtrl', ['$scope', 'mediaTagApiService', 'mediaTagService', 'modalDialog', 'trsspliceString',
    function($scope, mediaTagApiService, mediaTagService, modalDialog, trsspliceString){
        initStatus();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.itmes = [];
            $scope.name = '标签管理';
            $scope.queryParams = {
                scope: 'public',
                keyword: '',
                pageNum: 1,
                pageSize: 20,
                type: '',
            };
            $scope.page = {
                ITEMCOUNT: 0,
                CURRPAGE: 1,
                PAGESIZE: 20,
                PAGECOUNT: 1,
            };
            $scope.data = {
                selectedArray: []
            };
            $scope.status = {
                copyCurrPage: 1,
            };
        }

        /**
         * [requestData 获取数据]
         *
         * @return  {[type]}  [return description]
         */
        $scope.requestData = function() {
            $scope.loadingPromis = mediaTagApiService.getTagList(this.queryParams).then(function(data){
                if (data.code === '200'){
                    $scope.items = data.datas;
                    $scope.data.selectedArray = [];
                    $scope.page = $scope.transferPage(data.summary_info);  
                }
            });
        };

        $scope.transferPage = function(pageInfo) {
            return {
                ITEMCOUNT: pageInfo.total,
                CURRPAGE: pageInfo.pageNum,
                PAGESIZE: pageInfo.pageSize,
                PAGECOUNT: pageInfo.total === 0 ? 0 : Math.ceil(pageInfo.total / pageInfo.pageSize),
            };
        };

        
        $scope.pageChanged = function() {
            $scope.queryParams.pageNum = $scope.page.CURRPAGE;
            $scope.requestData();
        };

        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.queryParams.pageNum = $scope.status.copyCurrPage;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            $scope.requestData();
        };

        $scope.create = function(item) {
            mediaTagService.createMediaTag({
                id: item ? item.id : 0,
                type: $scope.queryParams.type,
                scope: 'public'
            }).then(function() {
                $scope.requestData();
            }, function(data) {
                modalDialog.alertType('', data.msg, 'error', false);
            });
        };

        $scope.delete = function(item) {
            modalDialog.confirmModal('删除', '确认删除标签', function() {
                mediaTagApiService.deleteTags({
                    type: $scope.queryParams.type,
                    ids: item ? item.id : trsspliceString.spliceString($scope.data.selectedArray, 'id', ',')
                }).then(function(data) {
                    if (data.code === '200') {
                        modalDialog.alertType('', '删除成功', 'success', false);
                        $scope.requestData();
                    } else {
                        modalDialog.alertType('', data.msg, 'error', false);
                    }
                });
            });
        };

        $scope.importTag = function() {
            let options = {
                type: $scope.queryParams.type,
            };
            mediaTagService.importMediaTag(options).then(function(data){
                if (data.code === '200'){
                    modalDialog.alertType('成功', '导入成功', 'success');
                    $scope.requestData();
                } else {
                    modalDialog.alertType('错误', '导入失败', 'error');
                }
            });
        };

        
        $scope.sort = function() {
            if ($scope.data.selectedArray.length > 1) {
                modalDialog.alertType('', '只能选择一个标签', 'warning', false);
                return;
            }
            
            mediaTagService.sort({
                id: $scope.data.selectedArray[0].id,
                total: $scope.page.ITEMCOUNT,
                orderNum: $scope.data.selectedArray[0].ordernum,
                type: $scope.queryParams.type,
                datas: $scope.items,
            }).then(function() {
                $scope.requestData();
            }, function(data) {
                modalDialog.alertType('', data.msg, 'error', false);
            });
        };

        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        $scope.selectAll = function() {
            if ($scope.data.selectedArray.length === $scope.items.length) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = $scope.items;
            }
        };
    }
]);
